<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'regional'"
            v-model="formulario.regional"
            :placeholder="'Nome da Regional'"
            data-vv-as="Nome da Regional"
            v-validate="'required|max:255'"
            :error="validationErrors.first('regional')"
          />
        </div>
        <div class="mb-3">
          <SGPFormSelectComponent 
            selecaoMultipla
            :name="'ctrl_modulos_ids'"
            :listaDeOptions="modulos"
            v-model="formulario.ctrl_modulos_ids"
            :optionLabel="'nome'"
            :placeholder="'Módulo'"
            :error="validationErrors.first('ctrl_modulos_ids')"
            data-vv-as="Módulos"
            :msgSemDados="'Nenhum módulo disponível'"
          />
        </div>
      </div>


      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button
              class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
              type="submit"
            >
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button
              class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
              type="button"
              @click="fecharModal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
    <SGPLoadingComponent v-if="loadingModulo"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FormularioCtrlRegionaisComponent',

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    regional: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      formulario: {
        id: this.regional.id || null,
        regional: this.regional.regional || '',
        ctrl_modulos_ids: this.getIdsModulos(this.regional),
      }
    }
  },

  created () {
    this.buscarModulosDoUsuarioLogado();
  },

  computed: {
    ...mapGetters('ctrlModulos', ['modulos', 'loadingModulo']),
  },

  methods: {
    ...mapActions('ctrlRegionais', ['salvarRegional', 'atualizarRegional']),
    ...mapActions('ctrlModulos', [
      'buscarModulosDoUsuarioLogado'
    ]),

    getIdsModulos (regional) {
      if (!regional?.ctrl_regionais_modulos) {
        return [];
      }

      return regional.ctrl_regionais_modulos.map(item => item.modulo_id);
    },

    async submit () {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      if (this.tipoFormulario === 'salvar') {
        await this.salvarRegional(this.formulario)
      } else {
        await this.atualizarRegional(this.formulario)
      }

      this.limparCampos()
      this.fecharModal()
    },

    limparCampos () {
      this.formulario = {
        regional: '',
        ctrl_modulos_ids: []
      }
      this.$validator.reset()
    },

    fecharModal () {
      this.$emit('fechar')
    }
  }
}
</script>
